import { Card, Field, useToast } from '../../../components/ui';
import { FLOATING_LABEL, ICON_LABEL, type CardProps } from './defaults';
import type { BannerAppearance } from '../../../lib/api';

type Reopen = BannerAppearance['reopen'];

const FOOTER_SNIPPET = '<a href="#" onclick="WekalpCookies.open(); return false">Cookie settings</a>';

export default function ReopenCard({ a, update, readOnly }: CardProps) {
  const toast = useToast();
  const r = a.reopen;
  const set = (patch: Partial<Reopen>) => update((x) => ({ ...x, reopen: { ...x.reopen, ...patch } }));

  return (
    <Card title="Reopen control">
      <div className="row">
        <Field label="Floating control" help="Shown after a choice is stored, so a returning visitor can change it.">
          <select value={r.floating} disabled={readOnly} onChange={(e) => set({ floating: e.target.value as Reopen['floating'] })}>
            {(Object.keys(FLOATING_LABEL) as Reopen['floating'][]).map((k) => <option key={k} value={k}>{FLOATING_LABEL[k]}</option>)}
          </select>
        </Field>
        <Field label="Icon">
          <select value={r.icon} disabled={readOnly || r.floating === 'off'} onChange={(e) => set({ icon: e.target.value as Reopen['icon'] })}>
            {(Object.keys(ICON_LABEL) as Reopen['icon'][]).map((k) => <option key={k} value={k}>{ICON_LABEL[k]}</option>)}
          </select>
        </Field>
      </div>
      <Field label="Footer link" help="Paste into the page footer; it reopens the banner.">
        <div className="ck-address">
          <input type="text" readOnly className="mono" value={FOOTER_SNIPPET} aria-label="Footer link" onFocus={(e) => e.currentTarget.select()} />
          <button
            className="small"
            onClick={() => navigator.clipboard.writeText(FOOTER_SNIPPET).then(() => toast('Copied.', 'ok'), () => toast('Copy failed.', 'bad'))}
          >
            Copy
          </button>
        </div>
      </Field>
    </Card>
  );
}
